import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { Row, Col, FormGroup, Label } from 'reactstrap';

import translations from 'services/translations/translations';
import AsyncSelect from 'react-select/async';
import TextInputField from '../forms/TextInputField';
import PrimaryButton from '../buttons/PrimaryButton';

import 'style/layout/Forms.css';
import 'style/layout/navbar/SaveNameModal.css';

const CreateProjectModal = ({
  show,
  setShow,
  create,
  placeholder,
}: {
  show: boolean;
  setShow: (close: boolean) => void;
  create: (name: string, status: string) => void;
  placeholder: string;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const [name, setName] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    setName(placeholder);
  }, [placeholder]);

  if (!show) {
    return null;
  }

  const availableStatuses = [
    'test',
    'presentation',
    'model',
    'advance',
    'offer',
    'project',
    'revoked',
    'disposed',
  ];

  const defaultOptions = (): any[] => {
    return availableStatuses.map((s) => ({
      value: s,
      label: t(`${translations.common}:statusTypes:${s}`),
    }));
  };

  const getSelected = () => {
    return defaultOptions().filter((i) =>
      i.value.toLowerCase().includes(status.toLowerCase())
    );
  };

  return (
    <Draggable>
      <div className="properties-edit-popup save-name-modal">
        <Row>
          <Col>
            <h2 onClick={() => setShow(false)}>&times;</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInputField
              id="name"
              label={t(`${translations.common}:Name`)}
              onChange={(e: any) => setName(e.target.value)}
              value={name}
              name="name"
              required
              className="edit-fields"
            />
            <FormGroup>
              <Label className="label">
                {t(`${translations.common}:Status`)}
              </Label>
              <AsyncSelect
                className="text-field search-field"
                isClearable
                name="status"
                defaultOptions={defaultOptions()}
                value={getSelected()}
                onChange={(e: any) => {
                  if (e) {
                    setStatus(e.value);
                  }
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <PrimaryButton
              onClick={() => create(name, status)}
              className="button-edit-popup"
            >
              {t(`${translations.common}:Save`).toLocaleUpperCase()}
            </PrimaryButton>
          </Col>
        </Row>
      </div>
    </Draggable>
  );
};

export default CreateProjectModal;
